import { AgTechButtonProps, AgTechActionButton, AgTechButton } from "@agtech/web/components/Buttons/AgTechButtons"
import SaleContactActionMenu from "../menus/SaleContactActionMenu"
import { ContactCredit } from "@sales/data/operation/contacts/credits/ContactCreditData"
import SaleContactCreditActionMenu from "../menus/SaleContactCreditActionMenu"
import { useContactCreditDataDeleteCreditAction } from "@sales/data/operation/contacts/credits/ContactCreditDataActions"
import { useContactDataDeleteContactAction } from "@sales/data/operation/contacts/SaleContactDataActions"
import SaleContactDetailPopUp from "../../popups/detail/SaleContactDetailPopUp"
import { AgTechContact } from "@agtech/data/contacts/ContactData"
import { ContactGridLink } from "@agtech/web/integrations/contacts/components/buttons/ContactLinks"

export type SaleContactButtonProps = AgTechButtonProps & {
    contact: AgTechContact
}

export const SaleContactActionButton = (props: SaleContactButtonProps) => {
    return (
        <AgTechActionButton>
            <SaleContactActionMenu contact={props.contact} />
        </AgTechActionButton>
    )
}

export const SaleContactRemovalButton = (props: SaleContactButtonProps) => {
    const deleteSaleContactAction = useContactDataDeleteContactAction();

    return (
        <AgTechButton
            text="Remove Contact"
            icon="fas fa-times"
            {...props}
            action={async e => {
                await e.actions.executeDataActionInModal(deleteSaleContactAction, {
                    originalEntity: props.contact,
                    submittedEntity: props.contact
                });
            }}
        />
    )
}

/// Credits

export const SaleContactCreditsActionButton = (props: SaleContactButtonProps & { credit: ContactCredit }) => {
    return (
        <AgTechActionButton>
            <SaleContactCreditActionMenu contact={props.contact} credit={props.credit} />
        </AgTechActionButton>
    )
}

export const SaleContactCreditRemovalButton = (props: { contactId: number, credit: ContactCredit }) => {
    const deleteCreditAction = useContactCreditDataDeleteCreditAction();

    let buttonProps: AgTechButtonProps = {
        text: 'Delete Credit',
        icon: 'fas fa-times',
        ...props,
        action: async e => await e.actions.executeDataActionInModal(deleteCreditAction, {
            originalEntity: props.credit,
            submittedEntity: props.credit
        })
    };

    return <AgTechButton {...buttonProps} />
}

///

export const SaleContactGridLink = (props: { contactName: string, contactId: number }) => {
    return (
        <ContactGridLink
            contactId={props.contactId}
            contactName={props.contactName}
            classes='!text-sm'
            onHover={contactId => ({
                popup: () => <SaleContactDetailPopUp contactId={contactId} />,
                config: {
                    topOffset: 24,
                    shouldCloseOnBlur: false
                }
            })}
        />
    )
}